import { Navigate, Route, Routes, useLocation } from 'react-router';
import { ErrorBoundary } from './components/ErrorBoundary';
import { DataDeletion } from './screens/DataDeletion';
import { DevMailbox } from './screens/DevMailbox';
import { Importing } from './screens/Importing';
import { Invite } from './screens/Invite';
import { Landing } from './screens/Landing';
import { AppNotFound, NotFound } from './screens/NotFound';
import { Review } from './screens/Review';
import { Signup } from './screens/Signup';
import { AppIndex, LegacyEditorRedirect } from './screens/app/AppIndex';
import { Calendar } from './screens/app/Calendar';
import { Channels } from './screens/app/Channels';
import { Composer } from './screens/app/Composer';
import { Media } from './screens/app/Media';
import { PostResults } from './screens/app/PostResults';
import { Posts } from './screens/app/Posts';
import { Reel } from './screens/app/Reel';
import { Settings } from './screens/app/Settings';
import { Shell } from './screens/app/Shell';
import { ForgotPassword } from './screens/auth/ForgotPassword';
import { Login } from './screens/auth/Login';
import { ResetPassword } from './screens/auth/ResetPassword';

export function App() {
  const { pathname } = useLocation();
  return (
    <div style={{ height: '100%', display: 'flex', overflow: 'hidden', position: 'relative' }}>
      {/* The Shell holds its own boundary around the page, so the sidebar survives a page crash. */}
      <ErrorBoundary key={pathname.startsWith('/app') ? '/app' : pathname}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/import/:importId" element={<Importing />} />
          <Route path="/review/:propertyId" element={<Review />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/onboarding/plan" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/invite/:token" element={<Invite />} />
          <Route path="/data-deletion" element={<DataDeletion />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/mailbox" element={<DevMailbox />} />
          <Route path="/app" element={<Shell />}>
            <Route index element={<AppIndex />} />
            <Route path="calendar" element={<Calendar />} />
            <Route path="create" element={<Composer />} />
            <Route path="reel" element={<Reel />} />
            <Route path="legacy" element={<LegacyEditorRedirect />} />
            <Route path="posts" element={<Posts />} />
            <Route path="posts/:id/results" element={<PostResults />} />
            {/* Hidden for launch (2026-10-19); the backend and "Made after" links stay. */}
            <Route path="inspiration" element={<Navigate to="/app" replace />} />
            <Route path="media" element={<Media />} />
            <Route path="channels" element={<Channels />} />
            <Route path="settings" element={<Settings />} />
            <Route path="*" element={<AppNotFound />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ErrorBoundary>
    </div>
  );
}
